"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import {ButtonBase} from "@/shared/ui/buttons/button-base";
import {assetPath} from "@/shared/utils/asset-path";

import type {DestinationListRenderProps} from "../destination-list";

export function ShuffleButton({actions}: DestinationListRenderProps): JSX.Element {
    const {t} = useTranslation("common");

    return (
        <ButtonBase variant="secondary-outline" size="sm" width="auto" onClick={actions.shuffle} className="destination__button-shuffle">
            {t("shuffle")}
            <SmartImage src={assetPath("/images/icons/icon-shuffle.svg")} alt="shuffle" width={16} height={16} />
        </ButtonBase>
    );
}
